/**
=========================================================
* Material Kit 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Kit 2 PRO React base styles
import borders from "../../base/borders";
import colors from "../../base/colors";

const { white,black } = colors;
const { borderWidth } = borders;

export default {
  styleOverrides: {
    root: {
      color: "#CDCDCD",
      transition: "all 200ms linear",

      "&.Mui-active": {
        // color: white.main,
        color: colors.JTCElectricBlue,
      },

      "&.Mui-completed": {
        // color: white.main,
        color: colors.JTCElectricBlue,
        opacity: 1,
      },
      "&.audittrail": {
        background: colors.error,
        backgroundColor: colors.error
      },
    },

    alternativeLabel: {
      top: "15%",
      left: "-50%",
      right: "50%",
    },

    line: {
      borderWidth: `${borderWidth[2]} !important`,
      borderColor: "currentColor",
      opacity: 0.7,
    },
  },
};
